<div class="footer">
  <div class="row">
    <div class="col-sm-10">
      <ul class="list-unstyled">
        <li>
          {{ website.name }}
        </li>
        <li>{{ 'TELEPHONE' | translate }}: {{ website.phone }}</li>
        <li>{{ 'EMAIL' | translate }}: {{ website.email }}</li>
        <li>
          {{ website.address }}
        </li>
        <li>
          {{ website.url }}
        </li>
      </ul>
    </div>
    <div class="col-sm-2">
      <div class="footer-powered">
        {{ 'POWERED_BY' | translate }}
        <div class="logo" title="TIM"></div>
      </div>
    </div>
  </div>
</div>
